import styled from "styled-components";

export const Box = styled.div`
    width: 200px;
    margin: auto;
    display: flex;
    flex-direction: row;
`;

export const CountBox = styled.div`
    flex: 1;
    position: relative;

    & + &:before {
        content: "";
        background: #c6c6c6;
        position: absolute;
        bottom: 15%;
        left: 0;
        height: 70%;
        width: 1px;
    }
`;

export const NumberBox = styled.div`
    font-weight: bold;
`;

export const DescriptionBox = styled.div`
    color: #868686;
`;
